/**
 * 売上票APIの日付（YYYY-MM-DD または先頭が日付のISO文字列）を「YYYY年MM月DD日」で返す。
 */
export function formatProfitDisplayDate(value: string | null | undefined): string {
  if (value == null || value === '') return '-';
  const datePart = value.split(/[T ]/)[0];
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(datePart);
  if (!match) return value;
  const [, year, month, day] = match;
  return `${year}年${month}月${day}日`;
}
